module.exports = __webpack_public_path__ + "media/images/map/airport-abd1ec8c8e84b7a81d10f93ad5e2cd1f.svg";